import * as yup from 'yup';

export const tipoRouterFormSchema = yup.object({
  nombre: yup.string().required('El campo nombre es requerido'),
  codigo: yup.string().required('El campo codigo es requerido'),
});
